import { GpsListType } from '../../enums/index';

export const gpsListTypeMap = [
    { type: GpsListType.PendingShip, url: 'pend-gps-assign', name: 'Pend GPS Assign' },
    { type: GpsListType.ShippedToMC, url: 'shipped-to-mc', name: 'Shipped to MC' },
    { type: GpsListType.PendingGps, url: 'pending-journey', name: 'Pend Journey' },
    { type: GpsListType.NeedsActivation, url: 'needs-activation', name: 'Needs Activation' },
    { type: GpsListType.InProcess, url: 'in-process', name: 'In Process' },
    { type: GpsListType.ReturnToNKR, url: 'return-to-nkr', name: 'Return to NKR' },
    { type: GpsListType.PendingNKRReceipt, url: 'pending-nkr-receipt', name: 'Pend NKR Receipt' },
]